import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [error, setError]     = useState('');
  const [sent, setSent]       = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Une erreur est survenue, réessayez');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="screen" style={{ background: 'var(--ink)', minHeight: '100vh' }}>
      <div style={{ height: 54 }} />
      <div style={{ padding: '8px 24px 40px', overflowY: 'auto' }}>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 32, marginBottom: 28 }}>
          <div className="display" style={{ fontSize: 36, lineHeight: 0.9, textAlign: 'center' }}>Mot de passe oublié</div>
          <div className="mono" style={{ color: 'var(--text-3)', marginTop: 10, textAlign: 'center', fontSize: 13 }}>
            On t'envoie un lien pour le réinitialiser
          </div>
        </div>

        {error && (
          <div style={{
            padding: '10px 14px', borderRadius: 10, marginBottom: 16,
            background: 'rgba(229,80,62,0.1)', color: '#E5503E',
            fontSize: 13, fontWeight: 600, border: '1px solid rgba(229,80,62,0.25)',
          }}>{error}</div>
        )}

        {sent ? (
          <div className="card col gap-2" style={{ padding: 18, textAlign: 'center' }}>
            <span style={{ color: 'var(--text)', fontSize: 14, lineHeight: 1.5 }}>
              Si un compte est associé à <strong>{email}</strong>, un e-mail avec un lien de
              réinitialisation vient d'être envoyé. Pense à vérifier tes spams.
            </span>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <div className="card col gap-2" style={{ padding: 14 }}>
              <span className="mono" style={{ color: 'var(--text-3)' }}>E-mail</span>
              <input
                type="email"
                placeholder="prenom@spike.fr"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  flex: 1, background: 'transparent', border: 0, outline: 'none', minWidth: 0,
                  color: 'var(--text)', fontSize: 14, fontFamily: 'inherit',
                }}
              />
            </div>

            <button type="submit" disabled={loading} className="btn btn-primary"
              style={{ width: '100%', marginTop: 8, padding: '15px 20px' }}>
              {loading ? 'Envoi en cours…' : 'Envoyer le lien'}
            </button>
          </form>
        )}

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 28, gap: 6 }}>
          <Link to="/login"
            style={{ color: 'var(--sun)', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>
            Retour à la connexion
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
